import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { driverGroupsSchema } from '../fleet/schemas/driver-groups.schema';
import { fleetEnvironment } from './fleet-environment';
import { DriverGroup } from './schemas/driver-groups.schema';
import { messageSchema } from './schemas/message-schema';

export function postDriverGroups(driverGroup: Partial<DriverGroup>[]) {
  return fromFetch(
    new Request(fleetEnvironment.driverGroupsUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
      body: JSON.stringify(driverGroup),
    })
  ).pipe(
    selectData(
      messageSchema.extend({
        data: driverGroupsSchema,
      })
    )
  );
}
